import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CheckboxField from '../CheckboxField';
import InputField from '../InputField';
import SelectField from '../SelectField';
import FormError from '../FormError';
import { formatSaveStatus } from 'helpers/formatters';
import Spinner from 'components/Spinner';

const oldCarrierOptions = [
  ['pwg', 'PWG'],
  ['tsp', 'Telispire'],
  ['other', 'Other'],
];

let PortForm = ({
  handleSubmit,
  error,
  saveStatus,
  oldCarrierValue,
  isUpdate,
  showEsim,
}) => (
  <div className="relative">
    <form onSubmit={handleSubmit}>
      {!isUpdate && (
        <Field
          component={SelectField}
          name="old_carrier"
          options={oldCarrierOptions}
          empty="Choose old carrier"
          label="Old Carrier"
        />
      )}
      {!isUpdate && <Field component={InputField} name="mdn" label="MDN" />}
      {(oldCarrierValue === 'other' || isUpdate) && (
        <React.Fragment>
          <Field
            component={InputField}
            name="carrier_account"
            label="Old Carrier Account"
          />
          <Field
            component={InputField}
            name="carrier_password"
            label="Old Carrier Password"
          />
          <Field
            component={InputField}
            name="address1"
            label="Address Line 1"
          />
          <Field
            component={InputField}
            name="address2"
            label="Address Line 2"
          />
          <Field component={InputField} name="city" label="City" />
          <Field component={InputField} name="state" label="State" />
          <Field component={InputField} name="zip_code" label="Zip Code" />
          {showEsim && !isUpdate && (
            <Field component={CheckboxField} name="esim" label="eSIM" />
          )}
        </React.Fragment>
      )}
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Save Port
      </button>
      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
    <Spinner showLoader={saveStatus === 'PENDING'} />
  </div>
);

const validate = (values, { isUpdate, oldCarrierValue }) => {
  let errors = {};

  if (!isUpdate && !values.old_carrier) {
    errors.old_carrier = 'Required';
  }

  if (!isUpdate && !values.mdn) {
    errors.mdn = 'Required';
  }

  if (!isUpdate && oldCarrierValue === 'other') {
    const requiredFields = [
      'carrier_account',
      'carrier_password',
      'address1',
      'city',
      'state',
      'zip_code',
    ];
    requiredFields.forEach((key) => {
      if (!values[key]) {
        errors[key] = 'Required';
      }
    });
  }

  return errors;
};

PortForm = reduxForm({
  form: 'port',
  validate,
  enableReinitialize: true,
})(PortForm);

export default PortForm;
